import { t } from "../i18n";

export default function HeroSection({ lang, onScrollToPlaylists, onOpenImmersive }) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50" />
      <div className="absolute inset-0 opacity-30">
        <svg className="w-full h-full" viewBox="0 0 400 300">
          {[...Array(12)].map((_, i) => (
            <circle
              key={i}
              cx={20 + (i % 4) * 120}
              cy={50 + Math.floor(i / 4) * 100}
              r={30 + i * 5}
              fill="none"
              stroke="currentColor"
              strokeWidth="0.5"
              className="text-indigo-300"
            />
          ))}
        </svg>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 py-24 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/70 backdrop-blur rounded-full text-sm text-gray-600 mb-6 border border-gray-200">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          {t(lang, "heroTag")}
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 tracking-tight leading-tight">
          {t(lang, "heroTitle")}
          <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
            {" "}
            {t(lang, "heroTitleGradient")}
          </span>
        </h1>

        <div className="max-w-2xl mx-auto">
          <p className="text-xl text-gray-600 mb-10 leading-relaxed">
            {t(lang, "heroDesc")}
          </p>
        </div>

        {/* Three CTA buttons */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
          {/* Immersive Play button */}
          <button
            onClick={onOpenImmersive}
            className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl transition shadow-lg shadow-indigo-200"
            style={{ textShadow: "0 1px 3px rgba(0,0,0,0.25)" }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
            {t(lang, "immersionPlay")}
          </button>
          <button
            onClick={() => { window.location.href = "/tracks"; }}
            className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-white text-gray-700 font-semibold rounded-xl border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition shadow-sm"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="M21 21l-4.35-4.35" />
            </svg>
            {t(lang, "scenePlaylist")}
          </button>
          <button
            onClick={onScrollToPlaylists}
            className="inline-flex items-center justify-center gap-2 px-4 py-3 bg-white text-gray-700 font-semibold rounded-xl border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition shadow-sm"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 18V5l12-2v13" />
              <circle cx="6" cy="18" r="3" />
              <circle cx="18" cy="16" r="3" />
            </svg>
            {t(lang, "userPlaylist")}
          </button>
        </div>
      </div>
    </section>
  );
}
